import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

  this.enableSlider()
    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }
 enableSlider() {
  const sliderEle = this.querySelector("#featured-drawer-slider");
  if (!sliderEle) return;

  if (sliderEle.swiper) {
    // Update existing swiper
    sliderEle.swiper.update();
    sliderEle.swiper.updateSlides();
    sliderEle.swiper.updateSize();
    return;
  }

  // First-time init
  new Swiper(sliderEle, {
    speed: 400,
    slidesPerView: 1.1,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-btn-next",
      prevEl: ".swiper-btn-prev",
    },
    observer: true,
    observeParents: true,
  });
}

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

document.addEventListener("cart:update",function() {
 const cartDrawer = document.querySelector("cart-drawer-component");
    requestAnimationFrame(() => {
    cartDrawer?.enableSlider();
  })
})